export enum CustomerStatus {
  Deleted = 0,
  Qualified = 1,
  Terminated = 2,
  Suspended = 3,
  TerminatedAlt = 4,
  FormerPetPro = 5,
  PendingCancellation = 6,
  PawClubQualified = 7,
  CancellationRequested = 8,
  AdvancedSubscription = 9,
}

export const CUSTOMER_STATUS_LABELS: Record<CustomerStatus, string> = {
  [CustomerStatus.Deleted]: 'Deleted',
  [CustomerStatus.Qualified]: 'Qualified',
  [CustomerStatus.Terminated]: 'Terminated',
  [CustomerStatus.Suspended]: 'Suspended',
  [CustomerStatus.TerminatedAlt]: 'Terminated',
  [CustomerStatus.FormerPetPro]: 'Former petPro',
  [CustomerStatus.PendingCancellation]: 'Pending Cancellation',
  [CustomerStatus.PawClubQualified]: 'Paw Club Qualified',
  [CustomerStatus.CancellationRequested]: 'Cancellation Requested',
  [CustomerStatus.AdvancedSubscription]: 'Advanced Subscription',
};
